<template>
  <div class="gestion">
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text">
            <CRow style="width:100%">
              <CCol md="6" lg="6" xl="6"> Gestión de labores </CCol>

            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow class="align-items-end flex-wrap mb-3" style="gap: 10px 0">
              <CCol md="6">
                <label class="d-block">Periodo:</label>
                <DateSelector class="z-custom-2 mb-2" v-model="selectedDate" :date="selectedDate"  />
              </CCol>
              <CCol md="6">
                <label class="d-block">Folio:</label>
                <CTextarea v-model="query.folio" placeholder="Folio" class="mb-0 align-self-center" :rows="1" />
              </CCol>
              <CCol md="6">
                <label class="d-block">Trabajador:</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="query.trabajadores"
                    :options="trabajadores"
                    :multiple="true"
                    :loading="isLoadingPage"
                    label="label"
                    track-by="label"
                    placeholder="Trabajadores"
                    :close-on-select="false"
                    :clear-on-select="false"

                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="query.trabajadores && query.trabajadores.length" @click="()=>{query.trabajadores = []}">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
              <CCol md="6" v-if="showUbicaciones">
                <label class="d-block">Ubicaciones:</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="query.ubicaciones"
                    :options="ubicaciones"
                    :multiple="true"
                    :loading="isLoadingPage"
                    label="label"
                    track-by="label"
                    placeholder="Ubicaciones"
                    :close-on-select="false"
                    :clear-on-select="false"

                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="query.ubicaciones && query.ubicaciones.length" @click="()=>{query.ubicaciones = []}">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
              <CCol md="6">
                <label class="d-block">Actividad:</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="query.actividades"
                    :options="actividades"
                    :multiple="true"
                    :loading="isLoadingPage"
                    label="label"
                    track-by="label"
                    placeholder="Actividades"
                    :close-on-select="false"
                    :clear-on-select="false"

                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="query.actividades && query.actividades.length" @click="()=>{query.actividades = []}">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>

              <CCol md="6">
                <label class="d-block">No. de Serie :</label>
                <CTextarea v-model="query.serie" placeholder="Serie" class="mb-0 align-self-center" :rows="1"/>
              </CCol>
              <CCol md="6">
                <label class="d-block">Cantidad Costo:</label>
                <CRow>
                  <CCol><CInput type="number" :value.sync="$v.query.cantidad_costo.start.$model" placeholder="De" class="mb-0 align-self-center" :isValid="query_cantidad_costo_start" /></CCol>
                  <CCol><CInput type="number" :value.sync="$v.query.cantidad_costo.end.$model" placeholder="Al" class="mb-0 align-self-center"  :isValid="query_cantidad_costo_end" /></CCol>
                </CRow>
              </CCol>
              <CCol md="6">
                <label class="d-block">Costo Unitario:</label>
                <CRow>
                  <CCol><CInput type="number" :value.sync="$v.query.costo_unitario.start.$model" placeholder="De" class="mb-0 align-self-center" :isValid="query_costo_unitario_start" /></CCol>
                  <CCol><CInput type="number" :value.sync="$v.query.costo_unitario.end.$model" placeholder="Al" class="mb-0 align-self-center"  :isValid="query_costo_unitario_end" /></CCol>
                </CRow>
              </CCol>
              <CCol md="6">
                <label class="d-block">Comentarios:</label>
                <CInput v-model="query.comentarios" placeholder="Comentarios" class="mb-0 align-self-center" />
              </CCol>

              <CCol md="6" v-if="mostrarColumnaAutor">
                <label class="d-block">Autor:</label>
                <CInput v-model="query.autor" placeholder="Autor" class="mb-0 align-self-center" />
              </CCol>


              <CCol col="10" class="pt-3">
                <CButton @click="validForm" color="primary"> Buscar</CButton>
              </CCol>
            </CRow>
            <CDataTable hover bordered small fixed :loading="isLoading" :items="items" :fields="headersTable"
              :items-per-page="limit" :noItemsView="noItems">
              <template #over-table>
                <CRow class="align-items-center mb-4 flex-wrap justify-content-end">

                  <div v-if="laboresIsSelected" class="ml-2 d-flex flex-column justify-content-end align-items-end">
                    <div class="d-flex justify-content-end align-items-center">
                      <CButton
                        @click="editModal = true"
                        color="primary"
                        class="mr-1 sp-width-butom  d-flex align-items-center"
                      >
                        <CIcon class="mr-1" name="cil-list" />Editar labores
                      </CButton>
                      <CButton
                        @click="show = true"
                        color="danger"
                        class="mr-1 sp-width-butom  d-flex align-items-center"
                      >
                        <CIcon class="mr-1" name="cil-list" />Cancelar labores
                      </CButton>
                    </div>
                    <label class="d-block text-right mt-2 mb-0">{{_countSelected_}} elementos selecciónados</label>
                  </div>
                  <div class="py-0 align-items-center px-3">
                    <CDropdown placement="bottom-start" add-menu-classes="pt-0" color="primary"
                      :show.sync="dropdownCustom">
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-settings" />
                        </CButton>
                      </template>

                      <template #default>
                        <div class="p-3 d-flex flex-column w-100">
                          <div class="mb-1">
                            <span>
                              <strong>Ver</strong>
                            </span>
                          </div>
                          <hr class="line mt-1 mb-3" />
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Ubicaciones:</label>
                            <CSwitch @update:checked="toggleUbicaciones()" class="mx-1" color="primary" variant="3d" />
                          </div>
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Cancelados:</label>
                            <CSwitch @update:checked="toggleShowCancel()" class="mx-1" color="primary" variant="3d" />
                          </div>
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Autor:</label>
                            <CSwitch @update:checked="toggleMostrarAutor()" class="mx-1" color="primary" variant="3d" />
                          </div>
                        </div>
                      </template>
                    </CDropdown>
                  </div>
                </CRow>
              </template>
              <!-- <template #loading>
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow">
                    <div class="sk-flow-dot bg-primary"></div>
                    <div class="sk-flow-dot bg-primary"></div>
                    <div class="sk-flow-dot bg-primary"></div>
                  </div>
                </div>
              </template>-->
              <template #check-header>
                <div v-if="items.length" class="">
                  <input id="all" type="checkbox" @input="checkAll" :checked="_laboresCheck_" class="ml-3" />
                </div>
              </template>
              <template #folio-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Folio</span>
                  <OrderButtons :onClick="sortField" :field="'doc_labores.folio'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #serie-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Serie</span>
                  <OrderButtons :onClick="sortField" :field="'doc_labores.serie'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #fechahora-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Fecha</span>
                  <OrderButtons :onClick="sortField" :field="'doc_labores.fechahora'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #trabajador_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Trabajador</span>
                  <OrderButtons :onClick="sortField" :field="'trabajador.payload->nombre'" :order="true" :fila="actualSortJoin" :direcction="sortingJoin"/>
                </div>
              </template>
              <template #actividad_id-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Actividad</span>
                  <OrderButtons :onClick="sortField" :field="'actividad.payload->nombre'" :order="true" :fila="actualSortJoin" :direcction="sortingJoin"/>
                </div>
              </template>
              <template #check="{item}">
                  <td class="py-2"><input v-model="laboresCheck[item.folio]" type="checkbox" class="form-check-input ml-3" /></td>
              </template>
              <template #folio="{item}">
                <td class="py-2">{{ item.folio }}</td>
              </template>
              <template #serie="{item}">
                <td class="py-2">{{ item.payload.encabezado.serie }}</td>
              </template>
              <template #fechahora="{item}">
                <td class="py-2">{{ getDate(item.fechahora) }}</td>
              </template>
              <template #estado="{item}">
                <td class="py-2">{{ item.estado }}</td>
              </template>
              <template #trabajador_id="{item}">
                <td class="py-2">{{ validarTrabajador(item.payload.encabezado) }}</td>
              </template>
              <template #actividad_id="{item}">
                <td class="py-2">{{ validarActividad(item.payload.encabezado) }}</td>
              </template>
              <template #ubicaciones="{item}">
                <td class="py-2">{{ validarUbicaciones(item.payload.encabezado) }}</td>
                <!-- <td class="py-2">{{ item.payload.encabezado._relaciones.ubicacion_raiz.payload.nombre }}</td> -->
              </template>
              <template #cantidad_costo="{item}">
                <td class="py-2">{{ $formatter(item.payload.encabezado.cantidad_costo,false,"",3) }}</td>
              </template>
              <template #costo_unitario="{item}">
                <td class="py-2">{{ $formatter(item.payload.encabezado.costo_unitario,true,"",3) }}</td>
              </template>
              <template #action="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'VerGestionLabores',
                      params: {
                        id: item.folio,
                        config: { page: page, dates: selectedDate },
                        backInfo: 'GestionLabores'
                      }
                    }"
                  >
                    <CButton color="success" square size="sm">Ver</CButton>
                  </router-link>
                </td>
              </template>
              <template #costo_total="{item}">
                <td class="py-2">
                  {{
                  $formatter(
                  Number(item.payload.encabezado.cantidad_costo) *
                  Number(item.payload.encabezado.costo_unitario),
                  true,"",3
                  )
                  }}
                </td>
              </template>
              <template #autor-header>
                <div class="d-flex flex-row">
                  <span v-show="mostrarColumnaAutor">Autor</span>
                </div>
              </template>
              <template #autor="{item}">
                <td class="py-2">
                  <span v-show="mostrarColumnaAutor">{{ item.author.correo }}</span>
                </td>
              </template>
              <template #under-table>
                <div class="footer-table">
                  <div style="gap: 5px" class="d-flex align-items-center justify-content-start">
                    Total {{total}} ,
                    <CSelect
                    :value="limit"
                    label=""
                    invalidFeedback="Campo requerido, debe seleccionar una opción"
                    :options="[10,25,50,100,1000]"
                    @update:value="v=>limit=v"
                    class="mb-0"
                    />{{" "}}artículos / página
                  </div>
                  <CPagination :activePage.sync="page" :pages="pages" align="center"
                    @update:activePage="e => actualizarInfo(e)" />
                </div>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

   <CModal :show.sync="editModal" :no-close-on-backdrop="true" :centered="false" title="Editar labores" color="info">
     <p class="text-center">Solo capture la información que requiere modificar, los demás campos debe dejarlos en blanco</p>
     <CRow class="py-2">
      <CCol sm="12" md="9" lg="9" >
        <label>Fecha:</label>
          <CInput
            v-model="edit.fechahora"
            type="date"
            :horizontal="{ input: 'col-sm-12' }"
            class="mb-0"
          />
      </CCol>
    </CRow>
    <CRow class="py-2">
      <CCol sm="12" md="9" lg="9" >
        <label>Trabajador:</label>
        <v-select
          v-model="edit.trabajador_id"
          :options="trabajadores"
          class="margin-multi"
          :loading="isLoadingPage"
          placeholder="Selecciona una trabajador"
        >
          <template #open-indicator="{ attributes }">
            <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
          </template>
        </v-select>
      </CCol>
    </CRow>

    <CRow class="py-2">
      <CCol sm="12" md="9" lg="9" >
        <label>Actividad:</label>
        <v-select
          v-model="edit.actividad_id"
          :options="actividades"
          class="margin-multi cursor-p"
          @input="filtrarActividad()"
          placeholder="Selecciona una actividad"
        >
          <template #open-indicator="{ attributes }">
            <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
          </template>
          <template #no-options>Sin resultados.</template>
        </v-select>
      </CCol>
    </CRow>

    <CRow class="py-2">
      <CCol sm="12" md="9" lg="9" >
        <CInput
          v-model="edit.cantidad"
          :label="`Cantidad producida${getUnidad}: `"
          placeholder="Cantidad producida..."
          type="number"
          class="mb-0"
        />
      </CCol>
    </CRow>

    <CRow class="py-2">
      <CCol sm="12" md="9" lg="9" >
        <CInput
          v-model="edit.costo_unitario"
          :label="`Costo unitario: `"
          placeholder="Costo..."
          type="number"
          class="mb-0"
        />
      </CCol>
    </CRow>

    <CRow class="py-2" >
      <CCol sm="11" md="8" lg="8">
        <CInput
          v-model="edit.cantidad_costo"
          :label="`Cantidad a pagar${getUnidadPagar}:`"
          placeholder="Cantidad a pagar..."
          type="number"
        />
      </CCol>
      <CCol>
      <!-- <CCol v-if="configurationToggle"> -->
        <label>Tiempo extra:</label>
        <br />
        <CSwitch :checked="edit.tiempo_extra" @update:checked="v=>edit.tiempo_extra=v" class="mx-1" color="primary" variant="3d" />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="9" lg="9" >
        <label>Ubicaciones:</label>
        <div class="d-flex margin-multi align-items-center">
          <multiselect
            v-model="edit.ubicaciones"
            :options="ubicaciones"
            :multiple="true"
            label="label"
            :loading="isLoadingPage"
            track-by="label"
            placeholder="Selecciona uno o varias ubicaciones"
            :close-on-select="false"
            :clear-on-select="false"
          >
            <template #no-options>Sin resultados.</template>
          </multiselect>
          <transition name="fade">
            <div v-show="edit.ubicaciones && edit.ubicaciones.length" @click="_=>{delete edit.ubicaciones}">
              <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
            </div>
          </transition>
        </div>
      </CCol>
    </CRow>

      <template #header>
        <h5 class="modal-title">Editar labores</h5>
        <CButtonClose @click="editModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="editModal = false" color="danger">Cancelar</CButton>
        <CButton @click="editarLabores()" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
     :closeOnBackdrop="false"
      size="sm"
      :title="loadingModal||''"
      :centered="true"
      color="info"
      :show.sync="loadingModal"
    >
      <template #footer>
        <strong></strong>
      </template>
      <div
        class="w-100 d-flex justify-content-center"
      >
        <div class="sk-flow align-items-center">
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
        </div>
      </div>
    </CModal>
    <CModal
      size="sm"
      title="Labores"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>
    <CModal
      size="sm"
      title=""
      :centered="true"
      :no-close-on-backdrop="true"
      color="danger"
      :show.sync="show"
    >
      <template #header>
        <h5 class="modal-title">Cancelar labores</h5>
        <CButtonClose @click="show = false" class="text-white" />
      </template>
    ¿Esta seguro que quiere cancelarlos?
    <template #footer>
        <CButton @click="show = false" color="danger">Cancelar</CButton>
        <CButton @click="cancelarLabores()" color="success">Aceptar</CButton>
    </template>
    </CModal>


  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import DateSelector from "../customComponents/DateSelector";
import vSelect from "vue-select";
import OrderButtons from "../customComponents/OrderButtons";
import GridAutorMixin from "../mixins/GridAutor";

import { validationMixin } from "vuelidate";

const fields = [
  {
    key: "check",
    label: "",
    _style: "width:5%"
  },
  {
    key: "folio",
    label: "Folio",
    _style: "width:10%"
  },
  // { key: "UBICACION_NOMBRE", label: "Ubicación", _style: "width:10%" },
  {
    key: "fechahora",
    label: "Fecha",
    _style: "width:10%"
  },
  {
    key: "estado",
    label: "Estado",
    _style: "width:10%"
  },
  {
    key: "trabajador_id",
    label: "Trabajador",
    _style: "width:10%"
  },
  {
    key: "ubicaciones",
    label: "Ubicaciones",
    _style: "width:25%"
  },
  {
    key: "actividad_id",
    label: "Actividad",
    _style: "width:10%"
  },
  {
    key: "serie",
    label: "Serie",
    _style: "width:10%"
  },
  // { key: "UNIDAD", label: "Unidad", _style: "width:10%" },
  // { key: "cantidad", label: "Cantidad", _style: "width:10%" },
  {
    key: "cantidad_costo",
    label: "Cantidad Costo",
    _style: "width:10%"
  },
  {
    key: "costo_unitario",
    label: "Costo Unitario",
    _style: "width:10%"
  },
  {
    key: "costo_total",
    label: "Costo Total",
    _style: "width:10%"
  },
  {
    key: "autor",
    label: "",
    _style: "width:1%",
  },
  {
    key: "action",
    label: "",
    _style: "width:1%",
  }
];
const fieldsNoLocation = [
  {
    key: "check",
    label: "",
    _style: "width:5%"
  },
  {
    key: "folio",
    label: "Folio",
    _style: "width:10%"
  },
  // { key: "UBICACION_NOMBRE", label: "Ubicación", _style: "width:10%" },
  {
    key: "fechahora",
    label: "Fecha",
    _style: "width:10%"
  },
  {
    key: "estado",
    label: "Estado",
    _style: "width:10%"
  },
  {
    key: "trabajador_id",
    label: "Trabajador",
    _style: "width:10%"
  },
  {
    key: "actividad_id",
    label: "Actividad",
    _style: "width:10%"
  },
  {
    key: "serie",
    label: "Serie",
    _style: "width:10%"
  },
  // { key: "UNIDAD", label: "Unidad", _style: "width:10%" },
  // { key: "cantidad", label: "Cantidad", _style: "width:10%" },
  {
    key: "cantidad_costo",
    label: "Cantidad Costo",
    _style: "width:10%"
  },
  {
    key: "costo_unitario",
    label: "Costo Unitario",
    _style: "width:10%"
  },
  {
    key: "costo_total",
    label: "Costo Total",
    _style: "width:10%"
  },
  {
    key: "autor",
    label: "",
    _style: "width:1%",
  },
  {
    key: "action",
    label: "",
    _style: "width:1%",
  }
];

export default {
  name: "GestionLabores",
  components: {
    vSelect,
    DateSelector,
    OrderButtons,
    Multiselect
  },
  mixins: [GridAutorMixin,validationMixin],
  validations: {
    query:{
      costo_unitario:{
        start:{
          maxValue: (v,costo_unitario)=>{
            return costo_unitario.start && costo_unitario.end ? Number(v) <= Number(costo_unitario.end) : true
          }
        },
        end:{
          minValue: (v,costo_unitario)=>{
            return costo_unitario.start && costo_unitario.end ? Number(v) >= Number(costo_unitario.start) : true
          }
        }
      },
      cantidad_costo:{
        start:{
          maxValue: (v,cantidad_costo)=>{
            return cantidad_costo.start && cantidad_costo.end ? Number(v) <= Number(cantidad_costo.end) : true
          }
        },
        end:{
          minValue: (v,cantidad_costo)=>{
            return cantidad_costo.start && cantidad_costo.end ? Number(v) >= Number(cantidad_costo.start) : true
          }
        }
      }
    }
  },
  data() {
    return {
      limit: 10,
      total: 0,
      loadingModal: false,
      isFijo: false,
      tiempo_extra: false,
      query:{
        costo_unitario:{start:'',end:''},
        cantidad_costo:{start:'',end:''},
      },
      laboresCheck: {},
      items: [],
      fields,
      fieldsNoLocation,
      labores: [],
      config: this.$route.params.config,
      dropdownCustom: false,
      show: false,
      showCancel: false,
      isCreated: false,
      filter: "",
      edit:{},
      noItems: {
        noResults: "Sin Resultados",
        noItems: "Sin Resultados"
      },
      ubicaciones: [],
      actualSort: "doc_labores.fechahora",
      actualSortJoin: "",
      cambioUbicacionRaiz: false,
      // ubicacionesAll: [],
      // cultivos: [],
      // cultivosAll: [],
      // lotes: [],
      showPagosDias : false,
      warningModal: false,
      actividades: [],
      actividadesAll: [],
      trabajadores: [],
      trabajadoresAll: [],
      error:"",
      empresa: "",
      trabajador: "",
      empresas: [],
      pagosDias : [],
      showTablePagosDias : false,

      showUbicaciones: false,


      editModal: false,
      isLoading: false,
      isLoadingPage: false,
      message : '',
      page: 1,
      pages: 1,
      sorting: "desc",
      sortingJoin: "",
      selectedDate: {
        start: moment()
          .startOf("month")
          .toDate(),

        end: moment()
          .endOf("month")
          .toDate()
      },
      loader:{},
    };
  },

  created() {
    this.fetchData()
    if (this.ubicacionRaiz == "") {
      this.items = []
      return
    }
    this.isCreated = false;

    this.page = this.config ? this.config.page : 1;
    this.selectedDate = this.config ? this.config.dates : this.selectedDate;
    // this.actualizarInfo();

  },

  computed: {
    query_cantidad_costo_start(){
      return this.$v.query.cantidad_costo.start.$dirty?!this.$v.query.cantidad_costo.start.$invalid:null
    },
    query_cantidad_costo_end(){
      return this.$v.query.cantidad_costo.end.$dirty?!this.$v.query.cantidad_costo.end.$invalid:null
    },
    query_costo_unitario_start(){
      return this.$v.query.costo_unitario.start.$dirty?!this.$v.query.costo_unitario.start.$invalid:null
    },
    query_costo_unitario_end(){
      return this.$v.query.costo_unitario.end.$dirty?!this.$v.query.costo_unitario.end.$invalid:null
    },
    payloadEdit(){
      const payload = Object.keys(this.edit).reduce((v,key)=>{
        if(this.edit[key]){
          if(['trabajador_id','actividad_id'].includes(key)){
            v[key] = this.edit[key].value
          } else if(key.includes('cantidad')||key.includes('costo')){
            v[key] = Number(this.edit[key])
          } else if(key==='ubicaciones'){
            v[key] = this.edit[key].map(m=>m.value)
          }else {
            v[key] = this.edit[key]
          }
        }
        return v
      },{})
      return payload
    },
    getUnidad() {
      if (this.edit.actividad_id) {
        // let tipo_pago = "";
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.payloadEdit.actividad_id
        );
        return actSelect ? ` (${actSelect.payload.unidad})` : "";
      }
      return "";
    },
    getUnidadPagar() {
      if (this.edit.actividad_id && this.edit.trabajador_id) {
        let tipo_pago = "";
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.payloadEdit.actividad_id
        );
        actSelect ? (tipo_pago = actSelect.payload.tipo_pago) : "";

        if (tipo_pago.toLowerCase() == "fijo") {
          const trabSelect = this.trabajadoresAll.find(
            trabajador => trabajador.id == this.payloadEdit.trabajador_id
          );
          if (trabSelect) {
            return this.tiempo_extra
              ? ` (${trabSelect.payload.unidad_extra})`
              : ` (${trabSelect.payload.unidad})`;
          }
        }
      }
      return "";
    },
    _countSelected_(){
      return Object.keys(this.laboresCheck).reduce((v,key)=>this.laboresCheck[key]?v+1:v,0)
    },
    _laboresCheck_(){
      return Object.keys(this.laboresCheck).length&&this.items.map(m=>m.folio).every(key=>this.laboresCheck[key])
    },
    docsLabores_(){
      return this.laboresCheck_.map(m=>{
        const doc = this.items.find(f=>f.folio===Number(m))
        const encabezado = JSON.parse(JSON.stringify(this.payloadEdit))
        if(this.payloadEdit.fechahora){
          const [, hora] = doc.payload.encabezado.fechahora.split(' ')
          encabezado.fechahora = `${this.payloadEdit.fechahora} ${hora}`
        }
        return{
        folio: m,
        serie: "",
        schema: "labores",
        payload:{
          encabezado
        }
      }})
    },
    docsLaboresRemplazar_(){
      return this.laboresCheck_.map(m=>{
        const doc = this.items.find(f=>f.folio===Number(m))
        const encabezadoActual = doc.payload.encabezado
        const encabezado = {
          fechahora: encabezadoActual.fechahora,
          trabajador_id: encabezadoActual.trabajador_id,
          actividad_id: encabezadoActual.actividad_id,
          tiempo_extra: encabezadoActual.tiempo_extra,
          ubicacion_raiz_id: encabezadoActual.ubicacion_raiz_id,
          cantidad: encabezadoActual.cantidad,
          nanoid: encabezadoActual.nanoid,
          ubicaciones: this.payloadEdit.ubicaciones
        }
        if(this.payloadEdit.fechahora){
          const [, hora] = encabezadoActual.fechahora.split(' ')
          encabezado.fechahora = `${this.payloadEdit.fechahora} ${hora}`
        }
        const camposObligatorios = ['trabajador_id','actividad_id','tiempo_extra','ubicacion_raiz_id','cantidad']
        camposObligatorios.forEach(key=>{
          if(Object.prototype.hasOwnProperty.call(this.payloadEdit, key)){
            encabezado[key] = this.payloadEdit[key]
          }
        })
        return{
          folio: m,
          serie: "",
          schema: "labores",
          payload:{
            encabezado
          }
        }
      })
    },
    docsLaboresCancel_(){
      return this.laboresCheck_.map(m=>({
        folio: m,
        serie: "",
        schema: "labores"
      }))
    },
    laboresIsSelected(){
      return Object.keys(this.laboresCheck).some(s=>this.laboresCheck[s])
    },
    laboresCheck_(){
      return Object.keys(this.laboresCheck).filter(ff=>this.laboresCheck[ff])
    },
    headersTable() {
      if (this.showUbicaciones) {
        return this.fields;
      } else {
        return this.fieldsNoLocation;
      }
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation ?
        this.$store.state.rootLocation.value :
        "";
    },
  },

  watch: {
    limit() {
      this.actualizarInfo()
    },
    showUbicaciones(newV,){
      if(!newV){
        delete this.query.ubicaciones
      }
    },
    mostrarColumnaAutor(newV,){
      if(!newV){
        delete this.query.autor
      }
    },
    editModal(newV,){
      if(!newV){
        this.edit = {}
      }
    },
    items(newV,){
      this.loader = newV.reduce((v,c,i)=>({...v,[i]:false}),{})
      Object.keys(this.laboresCheck).forEach(key=>{
        if (!newV.find(f=>f.folio === Number(key))) {
          delete this.laboresCheck[key];
        }
      })
    },
    ubicacionRaiz: function () {
      this.page = 1;
      if (this.ubicacionRaiz == "") {
        this.items = []
        return
      }
      this.cambioUbicacionRaiz = true
      this.fetchData()
      this.actualizarInfo();
    }
  },

  methods: {
    checkIfValid(fieldName) {
      const field = Object.byString(this.$v, fieldName);
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    fetchData(){
      this.isLoadingPage = true;
      const documento = []
      if (!this.isCreated || this.cambioUbicacionRaiz) {
        this.cambioUbicacionRaiz = false
        documento.push(this.$store.dispatch("customHTTP", { schema: "empresas" }))
        documento.push(this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
            filter: {
              where: [
                {
                  field: "payload->ubicaciones",
                  operator: "regexp",
                  value: `[[:<:]]${this.ubicacionRaiz}[[:>:]]`
                },
                {
                  field: "payload->suspendido",
                  value: false,
                  operator: "="
                }
              ],
            }
          })
        )
      }
      documento.push(this.ubicacionRaizValue
      ?this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->raiz_id",
            value: this.ubicacionRaizValue,
            operator: "="
          },
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    })
      :this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    }))
    documento.push(
      this.$store.dispatch("customHTTP", {
        schema: "actividades",
      }))
      Promise.all(documento).then(([ empresas, trabajadores, ubicaciones, actividades]) => {


        this.actividades = actividades.data.map(actividad => {
          return { value: actividad.id, label: actividad.payload.nombre };
        }).sort((a,b)=>a.label.localeCompare(b.label));
        this.actividadesAll = actividades.data

        this.empresas = empresas.data.map( empresa => {
          return {
            value : empresa.id,
            label : empresa.payload.nombre
          };
        });
        this.trabajadores = trabajadores.data.map(trabajador => {
          return {
            value: trabajador.id,
            label: trabajador.payload.nombre
          };
        }).sort((a,b)=>a.label.localeCompare(b.label));

        this.isCreated = true;
        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        }).sort((a,b)=>a.label.localeCompare(b.label));
        this.ubicacionesAll = ubicaciones.data;
      }).catch(error => {
        console.log( error.message);
      }).finally( () => {
        this.isLoading = false;
        this.isLoadingPage = false;
      });
    },
    checkAll(e){
        this.laboresCheck = this.items.reduce((v,c)=>{
          v[c.folio] = e.target.checked
          return v
        },{})

    },
    editarLabores(){
      this.isLoading = true
      this.loadingModal =  "Editando..."
      const remplazarUbicaciones = Object.prototype.hasOwnProperty.call(this.payloadEdit, 'ubicaciones')
      const actualizarOtrosCampos = Object.keys(this.payloadEdit).some(key => key !== 'ubicaciones')
      const requests = []
      if (actualizarOtrosCampos) {
        const docsLaboresActualizar = this.docsLabores_.map(doc => {
          const documento = JSON.parse(JSON.stringify(doc))
          delete documento.payload.encabezado.ubicaciones
          return documento
        })
        requests.push(this.$store.dispatch("customDocumentoActualizarHTTP", docsLaboresActualizar))
      }
      if (remplazarUbicaciones) {
        this.docsLaboresRemplazar_.forEach(doc => {
          requests.push(this.$store.dispatch("customDocumentoRemplazarHTTP", doc))
        })
      }
      const request = Promise.all(requests)
      request
          .then((res)=>{
            const responses = Array.isArray(res) ? res : [res]
            const data = responses.reduce((acc, response) => {
              if (Array.isArray(response)) {
                return [...acc, ...response]
              }
              if (Array.isArray(response?.data)) {
                return [...acc, ...response.data]
              }
              return response?.data ? [...acc, response.data] : acc
            }, [])
            const found = data.find(f=>f.status==='error'||f.status==='fail');
            if(!found){
              this.editModal = false
              this.edit = {}
              this.actualizarInfo()
            } else {
            this.error = found.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
            }
          })
          .catch(rej => {
            debugger
            console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
          })

          .finally(() => {
            debugger
            this.isLoading = false
            this.loadingModal =  false
          })
    },
    cancelarLabores(){
      this.show = false
      this.isLoading = true
      this.isLoading = false

      this.loadingModal =  "Cancelando..."
      this.$store.dispatch("customDocumentoCancelHTTP",this.docsLaboresCancel_)
          .then(()=>{
            this.actualizarInfo()
          })
          .catch(rej => {
            console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
            return;
          })

          .finally(() => {
            this.editModal = false
            this.edit = {}
            this.isLoading = false
            this.loadingModal = false
          })
    },
    validarTrabajador(trabajador) {
      if(trabajador._relaciones.trabajador != null) {
        return trabajador._relaciones.trabajador.payload.nombre
      }
      // else{
        //   const trabajadorActual = this.trabajadores.filter(
          //     trabajador => trabajador.id == trabajador.trabajador_id
      //   );
      //   if (trabajadorActual.length > 0) {
        //     // return trabajadorActual[0].payload.nombre;
      //     return trabajadorActual[0].label
      //   } else {
        //     return "";
      //   }
      // }
    },
    validarActividad(actividad){
      if(actividad._relaciones.actividad != null) {
        return actividad._relaciones.actividad.payload.nombre
      }
    },
    validarUbicaciones(ubicaciones) {
      if (ubicaciones._relaciones.ubicacion != null) {
        var ubicacionesAll = ""
        Object.values(ubicaciones._relaciones.ubicacion).forEach(ubicacion => {
          ubicacionesAll += ubicacion.payload.nombre + ", "
        })
        return ubicacionesAll
      }
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },
    toggleUbicaciones() {
      this.showUbicaciones = !this.showUbicaciones;
    },
    toggleShowCancel() {
      this.showCancel = !this.showCancel;
      this.actualizarInfo();
    },
    sortField(field, direction, join) {
      if (join) {
        this.actualSort = ""
        this.sorting = ""
        this.actualSortJoin = field
        this.sortingJoin = direction
      }else{
        this.actualSort = field
        this.sorting = direction
        this.actualSortJoin = ""
        this.sortingJoin = ""
      }
      this.actualizarInfo();
    },
    getDate(date) {

      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    validForm(){
      this.$v.$reset();
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.actualizarInfo()
      }
    },
    actualizarInfo(){
      this.$v.$reset();
      const ubicacionesIds = this.query?.ubicaciones?.map(m=>m.value)||[]
      const trabajadoresIds = this.query?.trabajadores?.map(m=>m.value)||[]
      const actividadesIds = this.query?.actividades?.map(m=>m.value)||[]
      if (this.ubicacionRaiz == "") {
        this.items = []
        return
      }

      this.isLoading = true;
      let template = {
        schema: "labores",
        limit: this.limit,
        page: this.page,
        filter: {
          wherein: [{
            field: "doc_labores.payload->encabezado->ubicacion_raiz_id",
            value: [this.ubicacionRaiz]
          }],
          where: [
            {
              field: "doc_labores.fechahora",
              operator: ">=",
              value: moment(this.selectedDate.start).format("YYYY-MM-DD 00:00:00")
            },
            {
              field: "doc_labores.fechahora",
              operator: "<=",
              value: moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59")
            }
          ]
        },
        ["with-storage"]: ["*"]
      };

      this.actualSort != "" ? (template = {
        ...template,
        order: [{
          field: this.actualSort,
          direction: this.sorting
        }]
      }) : null

      this.actualSortJoin != "" ? (template = {
        ...template,
        orderByJoin: [{
          field: this.actualSortJoin,
          direction: this.sortingJoin
        }]
      }) : null
      template = {
        ...template, filter: {
          ...template.filter,
          and: {
            where: [
              ...this.query.folio?[{
                field: "doc_labores.folio",
                operator: "regexp",
                value: `[[:<:]](${this.query.folio.split('\n').sort().join('|')})[[:>:]]`,
                collate: "utf8mb4_unicode_ci"
              },
              ]:[],
              ...this.query.serie?[{
                field: "doc_labores.payload->encabezado->serie",
                operator: "regexp",
                value: `[[:<:]](${this.query.serie.split('\n').sort().join('|')})[[:>:]]`,
                collate: "utf8mb4_unicode_ci"
              },
              ]:[],
              ...this.query.comentarios?[{
                field: "doc_labores.payload->encabezado->comentarios",
                operator: "like",
                value: `%${this.query.comentarios}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ]:[],
              ...this.query.cantidad_costo.start?[{
                field: "doc_labores.payload->encabezado->cantidad_costo",
                operator: ">=",
                value:  Number(this.query.cantidad_costo.start),
              }]:[],
              ...this.query.cantidad_costo.end?[{
                field: "doc_labores.payload->encabezado->cantidad_costo",
                operator: "<=",
                value:  Number(this.query.cantidad_costo.end),
              },
              ]:[],
              ...this.query.costo_unitario.start?[{
                field: "doc_labores.payload->encabezado->costo_unitario",
                operator: ">=",
                value:  Number(this.query.costo_unitario.start),
              }]:[],
              ...this.query.costo_unitario.end?[{
                field: "doc_labores.payload->encabezado->costo_unitario",
                operator: "<=",
                value:  Number(this.query.costo_unitario.end),
              },
              ]:[],
              ...this.mostrarColumnaAutor&&this.query.author?[
              {
                field: "doc_labores.author->correo",
                operator: "like",
                value: `%${this.author}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ]:[],
              ...this.showUbicaciones&&ubicacionesIds.length?[
              {
                field: "doc_labores.payload->encabezado->ubicaciones",
                operator: "regexp",
                value: `[[:<:]](${ubicacionesIds.join('|')})[[:>:]]`
              },
              ]:[],
            ],
            whereJoin:[
              ...trabajadoresIds.length?[
              {
                field: "trabajador.id",
                operator: "regexp",
                value: `[[:<:]](${trabajadoresIds.join('|')})[[:>:]]`
              },
              ]:[],
              ...actividadesIds.length?[
              {
                field: "actividad.id",
                operator: "regexp",
                value: `[[:<:]](${actividadesIds.join('|')})[[:>:]]`
              },
              ]:[],
            ]
          }
        }
      };

      if(template.filter.and.where.length === 0){
        delete template.filter.and.where
      }
      if(template.filter.and.whereJoin.length === 0){
        delete template.filter.and.whereJoin
      }
      if(Object.keys(template.filter.and).length===0){
        delete template.filter.and
      }

      !this.showCancel ? (template = {
        ...template, filter: {
          ...template.filter,
          where: [
            ...template.filter.where,
            {
              field: "doc_labores.estado",
              operator: "!=",
              value: "cancelado"
            }
          ]
        }
      }) : null;


      this.$store.dispatch("customDocumentoHTTP", template).then((documentos)=>{
        this.total = documentos?.paginate?.total||0
        this.items = documentos.data;
        this.pages = documentos?.paginate?.last_page;
        this.page = documentos?.paginate?.current_page;
      }).finally( () => {
        this.isLoading = false;
        this.isLoadingPage = false;
      });

    },

    filtrarActividad() {
      debugger
      if (this.edit.actividad_id) {
        // console.log();
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.payloadEdit.actividad_id
        );
        if(actSelect.payload.tipo_pago.toLowerCase() === "fijo"){
          this.isFijo = true
        }else{
          this.isFijo = false
          this.tiempo_extra = false
        }
      } else{
        this.isFijo = false
        this.tiempo_extra = false
      }
      console.log(this.tiempo_extra)
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>
<style>
.gestion .multiselect__spinner{
  height: 30px;
}
.gestion .multiselect__placeholder{
  margin-bottom: 0px;
}
.gestion .multiselect__select{
  height: 34px;
}
.gestion .multiselect__tags{
    max-height: 35px;
    overflow: auto;
    min-height: unset;
    padding: 5px 40px 5px 5px;
}
</style>
<style scoped>
.line {
  width: 100%;
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}

.custom-width-btn {
  width: 40%;
}
.custom-heigth-btn {
  width: 100%;
}
.custom-font-size {
  font-size: 1rem;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
.footer-table{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
</style>
